module.exports = __webpack_public_path__ + "img/8.cd6a3a88.jpg";